import { createBrowserRouter, Navigate } from 'react-router-dom';
import Layout from '../components/Layout';
import PortalLayout from '../components/PortalLayout';
import RequireAuth from '../components/RequireAuth';
import HomeLeadMagnet from '../pages/HomeLeadMagnet';
import TemplatesTripwire from '../pages/TemplatesTripwire';
import Checkout from '../pages/Checkout';
import ThankYou from '../pages/ThankYou';
import Audit from '../pages/Audit';
import AdminDashboard from '../pages/AdminDashboard';
import LegalPrivacy from '../pages/LegalPrivacy';
import LegalTerms from '../pages/LegalTerms';
import VerifyEmail from '../pages/VerifyEmail';
import MagicLink from '../pages/MagicLink';
import NotFound from '../pages/NotFound';

// Portal pages
import Dashboard from '../pages/Portal/Dashboard';
import JourneyNew from '../pages/Portal/JourneyNew';
import Downloads from '../pages/Portal/Downloads';
import Products from '../pages/Portal/Products';
import ProductDetail from '../pages/Portal/ProductDetail';
import Settings from '../pages/Portal/Settings';
import BusinessStructureWizard from '../components/tools/BusinessStructureWizard';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomeLeadMagnet />,
      },
      {
        path: 'templates',
        element: <TemplatesTripwire />,
      },
      {
        path: 'checkout/:productId',
        element: <Checkout />,
      },
      {
        path: 'thank-you',
        element: <ThankYou />,
      },
      {
        path: 'account',
        element: <Navigate to="/portal" replace />,
      },
      {
        path: 'audit',
        element: <Audit />,
      },
      {
        path: 'admin',
        element: <AdminDashboard />,
      },
      {
        path: 'privacy',
        element: <LegalPrivacy />,
      },
      {
        path: 'terms',
        element: <LegalTerms />,
      },
      {
        path: 'verify-email',
        element: <VerifyEmail />,
      },
      {
        path: 'magic-link',
        element: <MagicLink />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  // Portal routes (protected)
  {
    path: '/portal',
    element: (
      <RequireAuth>
        <PortalLayout />
      </RequireAuth>
    ),
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: 'downloads',
        element: <Downloads />,
      },
      {
        path: 'journey',
        element: <JourneyNew />,
      },
      {
        path: 'business-structure-wizard',
        element: <BusinessStructureWizard />,
      },
      {
        path: 'products',
        element: <Products />,
      },
      {
        path: 'products/:productId',
        element: <ProductDetail />,
      },
      {
        path: 'settings',
        element: <Settings />,
      },
    ],
  },
]);
